import { takeLatest, fork } from "redux-saga/effects";
import { userNotesRoutine } from "./index";

import ApiClient from "../../../api/ApiClient";

function* onSaveNote({ payload }) {
  try {
    yield ApiClient.put({
      urlPath: "app.notices.save",
      variables: {
        noticeId: payload.id
      },
      data: payload
    });
  } catch (error) {
    console.log(error);
  }
}

function* watchSaveNote() {
  yield takeLatest(userNotesRoutine.TRIGGER, onSaveNote);
}

export default [fork(watchSaveNote)];
